import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, TextField, Typography } from '@mui/material';

import { validateShareholdingStyles } from '../styles';
import ShareholderAutocomplete from './ShareholderAutocomplete';

const AddShareholding = ({
  shareholderId,
  onSetShareholderId,
  onSubmit,
  companyId,
  onAddNewShareholder,
  newShareholderName,
}) => {
  const { t } = useTranslation();
  const [holding, setHolding] = useState<number | null>(null);
  const holdingInputRef = useRef<HTMLInputElement>(null);

  const handleSubmit = e => {
    e.preventDefault();
    try {
      onSubmit(holding, holding);
      handleReset();
    } catch {}
  };

  const handleReset = () => {
    setHolding(null);
  };

  useEffect(() => {
    if (shareholderId && holdingInputRef.current) {
      holdingInputRef.current.focus();
    }
  }, [shareholderId]);

  return (
    <Box mt={6} gap={2} display="flex" flexDirection="column">
      <Typography fontWeight="500">
        {t('validation.validateShareholdingManagement.shareholdingAddShareholdingTitle')}
      </Typography>

      <ShareholderAutocomplete
        shareholderId={shareholderId}
        onSetShareholderId={onSetShareholderId}
        onAddNewShareholder={onAddNewShareholder}
        companyId={companyId}
        newShareholderName={newShareholderName}
      />

      <Box onSubmit={handleSubmit} component="form" display="flex" flexDirection="column" gap={2}>
        <TextField
          label={t('validation.validateShareholdingManagement.shareholdingAddShareholdingInputHoldingLabel')}
          type="number"
          value={holding !== null ? holding : ''}
          onChange={e => {
            const value = e.target.value;
            const numValue = value === '' ? null : Number(value);
            if (numValue === null || (numValue >= 1 && numValue <= 100)) {
              setHolding(numValue);
            }
          }}
          inputProps={{
            min: 1,
            max: 100,
          }}
          inputRef={holdingInputRef}
          fullWidth
          size="small"
          required
          helperText="Value must be between 1 and 100"
        />
        <Button
          sx={validateShareholdingStyles.addShareHoldingAddButton}
          variant="contained"
          color="primary"
          type="submit"
          disabled={!holding || !shareholderId || holding < 1 || holding > 100}
        >
          {t('validation.validateShareholdingManagement.shareholdingAddShareholdingAddButton')}
        </Button>
      </Box>
    </Box>
  );
};

export default AddShareholding;
